<template>
    <div class="container-fluid">
        <v-title :breadcrumb="{label: 'Orders', route: {name: 'orders'}, root: true}">
            Orders
        </v-title>
        <div class="grid">
            <div class="grid-item">
                <grid
                    :columns="gridColumns"
                    :provider="provider"
                    @completed="stopLoadingPage"
                    :tabs="gridTabs"
                    :filter-set="gridFilterSet"
                >
                    <v-no-content slot="no-content">
                        <span slot="title">It seems that you have no orders</span>
                    </v-no-content>
                </grid>
            </div>
        </div>
    </div>
</template>

<script>
    import vTitle from '@/components/v-title';
    import vNoContent from '@/components/v-no-content';
    import Grid from '@/components/grid/grid';
    import LoadStateMixin from '@/mixins/load-state-mixin';
    import TabsConfiguration from '@/components/grid/tabs/tabs-configuration';
    import orderFilters from '@/common/query/filter/order-filters';
    import orderColumns from './order-columns';
    import FilterSet from '@/components/query/filter-set';

    export default {
        name: 'orders',
        components: {
            vTitle, Grid, vNoContent,
        },
        mixins: [LoadStateMixin],
        data() {
            return {
                gridColumns: orderColumns,
                gridTabs: new TabsConfiguration({
                    id: 'order-list',
                    store: this.$store,
                    systemTabs: [
                        {
                            label: 'All',
                            sortBy: {renewalTime: 'desc'},
                        },
                        {
                            label: 'Subscriptions',
                            sortBy: {renewalTime: 'desc'},
                            filter: [['orderType', ['subscription-order']]],
                        },
                        {
                            label: 'One-time',
                            sortBy: {renewalTime: 'desc'},
                            filter: [['orderType', ['one-time-order']]],
                        },
                    ],
                    version: 4,
                    filtersVersion: orderFilters.version,
                }),
                gridFilterSet: new FilterSet({store: this.$store, ...orderFilters}),
            };
        },
        methods: {
            provider(params) {
                return this.$api(({subscriptions}) => subscriptions.getAll(params));
            },
        },
    };
</script>
